import React from 'react';
import { Box, Divider, Link, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

const AppFooter = () => {
  const theme = useTheme();
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        mt: 6,
        py: 4,
        borderTop: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        background: theme.palette.background.paper,
      }}
    >
      <Box sx={{ width: '100%', px: { xs: 2, sm: 3, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
        >
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 800 }}>
              SG DIGITAL • Facteio
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block">
              © {year} — Tous droits réservés
            </Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 1, sm: 2 }}>
            <Link component={RouterLink} to="/conditions-generales" underline="hover" color="text.primary" sx={{ fontWeight: 600 }}>
              Conditions générales
            </Link>
            <Link component={RouterLink} to="/mentions-legales" underline="hover" color="text.primary" sx={{ fontWeight: 600 }}>
              Mentions légales
            </Link>
            <Link component={RouterLink} to="/contact" underline="hover" color="text.primary" sx={{ fontWeight: 600 }}>
              Contact
            </Link>
          </Stack>
        </Stack>

        <Divider sx={{ my: 2, opacity: 0.35 }} />

        <Typography variant="caption" color="text.secondary">
          Besoin d'aide ? Écrivez-moi :{' '}
          <Link href="mailto:sgdigitalweb13@gmail.com" underline="hover">
            sgdigitalweb13@gmail.com
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default AppFooter;
